import { Diagram, GraphObject, Part, Point, Spot } from 'gojs';

export const getTopCenterObjectPoint = (graphObject?: Part | null) => {
  if (!graphObject) {
    return { x: 0, y: 0 };
  }

  const diagram = graphObject.diagram;
  if (!diagram) {
    return { x: 0, y: 0 };
  }
  const { leftOffset, topOffset } = getDiagramOffset(diagram);
  const { x, y, width } = diagram.computePartsBounds([graphObject]);
  const { x: documentPointX, y: documentPointY } = diagram.transformDocToView(new Point(x + width / 2, y));

  return {
    x: documentPointX + leftOffset,
    y: documentPointY + topOffset,
  };
};

export const getTopLeftObjectPoint = (graphObject: GraphObject) => {
  const { leftOffset, topOffset } = getDiagramOffset(graphObject.diagram);
  const { x, y } = graphObject.getDocumentPoint(Spot.TopLeft);
  const { x: documentPointX, y: documentPointY } = graphObject.diagram?.transformDocToView(new Point(x, y)) || {
    x: 0,
    y: 0,
  };

  return {
    x: documentPointX + leftOffset,
    y: documentPointY + topOffset,
  };
};

export const getTopRightObjectPoint = (obj: GraphObject) => {
  const { leftOffset, topOffset } = getDiagramOffset(obj.diagram);
  const { x, y } = obj.getDocumentPoint(Spot.TopRight);
  const { x: documentPointX, y: documentPointY } = obj.diagram?.transformDocToView(new Point(x, y)) || {
    x: 0,
    y: 0,
  };

  return {
    x: documentPointX + leftOffset,
    y: documentPointY + topOffset,
  };
};

const getDiagramOffset = (diagram: Diagram | null) => {
  const { top, left } = diagram?.div?.getBoundingClientRect() || { top: 0, left: 0 };

  return {
    leftOffset: left,
    topOffset: top,
  };
};
